"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormHelperText.default;
  }
});

var _FormHelperText = _interopRequireDefault(require("./FormHelperText"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/FormHelperText/index.js
// module id = 160
// module chunks = 44632231052062 144482932168434